import { render, staticRenderFns } from "./CompositeItem.vue?vue&type=template&id=03f7c54a&scoped=true"
import script from "./CompositeItem.vue?vue&type=script&lang=js"
export * from "./CompositeItem.vue?vue&type=script&lang=js"
import style0 from "./CompositeItem.vue?vue&type=style&index=0&id=03f7c54a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f7c54a",
  null
  
)

export default component.exports